import { Component } from "react";

class TOSComponent extends Component{
    render = () => {
        const tosStyle = {
            color: "white",
            padding: "1em",
            fontSize: "1.8em"
        }
        return (
        <div className="tos-section">
            <h2>Terms of Service</h2>
<p>Last updated Apr. 26, 2022</p>
<p></p>
<p>AGREEMENT TO TERMS</p>
    <h3>Eligability</h3>
<p>The services provided by VideoPulse are not targeted 
    towards, nor intended for use by anyone under 
    the age of 13. By using the service, you represent and warrant 
    that you are 13 years of age or older. If you are under the 
    age of 13, you  may not use the service. We may, in our sole 
    discretion refuse to offer the service to any person or entity and 
    change it's eligibility criteria at any time. You are solely 
    resonsible for ensuring that these Terms of Service are in compliance 
    with all laws, rules andd regulations applicable to you and the right to 
    access the service is revoked where these Terms of Service or use of the 
    service is prohibited or to the extent offering, sale or provision of the 
    service conflicts with any applicable law, rule or regulation. Further, 
    the service is offered only for your use, and not for the benefit of any 
    third party.
</p>
<h3>User Guidelines</h3>
<p>Please make sure you are familiar with our rules for conduct on this site. When you 
    follow the guidelines, VideoPulse will provide an experience that should be 
    equally enjoyable for everyonee who uses the site.
</p>
<p>
    The following is not permitted on VideoPulse:   
</p>
<ol>
    <li>Using VideoPulse import or copy any local files that you do not have the legal rights to import or copy in this way;</li>
    <li>Transferring copies of cached content from an authorized device to any other device via any means;</li>
    <li>Reverse-engineering, decompliling, dissassembling, modifying, or creating derivative works on services provided by VideoPulse, content or any part thereof except to the extent permitted by applicable law;</li>
    <li>Circumventing technology used by VideoPulse, its licensors, or any third party to protect the content or the service;</li>
    <li>Selling, renting, sublicensing or leasing any part of the VideoPulse service or the content;</li>
    <li>Circumventing any territorial restrictions applied by VideoPulse or its licensors;</li>
    <li>Artificilly inflating ratings or vote counts on the service by:
        <ol style={{listStyleType: "lower-roman"}}>
            <li>using any script, bot or other automated process;</li>
            <li>providing or accepting any form of compensation (financial or otherwise), or</li>
            <li>any other means;</li>
        </ol>
    </li>
    <li>Removing or altering any copyright, trademark, or any other intellectual property notices contained on the content or the service 
        or provided through the service (including for the purpose of disguising or changing any indications of ownership or source of any 
        content);
    </li>
    <li>Circumventing or blocking advertisements in the VideoPulse service, or creating or distributing tools designed to block advertisements 
        in the VideoPulse service;
    </li>
    <li>Providing your password to any other person or using any other person's username and password;</li>
    <li>"Crawling" the VideoPulse service or otherwise using any automated means (including bots, scrapers and spiders) to view access or collect information 
        from VideoPulse or the VideoPulse service.
    </li>
    <li>Selling a user account, media list or review, or otherwise accepting any compensation ( financial or otherwise), to influence the name an account or content included on an account, review or media list; or</li>
    <li>Artifically promoting content by automated means or otherwise.</li>
    <li>Uploading or creating content or dipictions of graphic sexuality or violence;</li>
    <li>Using the service to create or upload content promoting violence or activities which infringe upon applicable laws, rules or regulations;</li>
</ol>
<h3>Account suspension or termination</h3>
<p>If it is determined that you have violated these terms of service, we may take action 
    against your account to protect the community and the services we provide, including suspending 
    your access to your account or disabling it. We may also suspend or disable your account if you create 
    risk or legal exposure for us or when we are permitted or required to do so by law. Where appropriate, 
    we will notify you about your account the next time you try to access it.
</p>
<p>
    If you delete or disable your account, these terms shall terminate as an agreement between you, the user, and 
    us.
</p>
<h3>Disclaimer of warranties and limitation of liabilities</h3>
<p>
    VideoPulse services and all information, content, materials, products (including software) 
    and other services included on or otherwise made available to you though VideoPulse are 
    provided by VideoPulse on an "as is" and "as available" basis, unless otherwise specified in 
    writing. VideoPulse makes no representations or warranties of any kind, express or implied, as to the 
    operation VideoPulse services, or the information, content, materials, products (including software) 
    of other services included on or otherwise made available to you through VideoPulse services, unless otherwise 
    specified in writing. You expressly agree that your use of VideoPulse is at your sole risk.
</p>
<p>
    To the full extent permissable by law, VideoPulse disclaims all warranties, express or implied,
    including, but not limited to, implied warranties of merchantability and fitness for a particular 
    purpose. VideoPulse does not warrant that the VideoPulse services, information, content, materials, products (including software) 
    or other services included on or otherwise made available to you through VideoPulse, the VideoPulse servers or electronic 
    communications sent from VideoPulse are free from viruses or other harmful components. To the full extent permissable 
    by law, VideoPulse will not be liable for any damages of any kind arrising from the use of any VideoPulse 
    service, or from information, content, materials, products (including software) or the services included on 
    or otherwise made available to you through any VideoPulse service, including, but not limited to direct, indirect, incidental, 
    punitive, and consequential damages, unless otherwise specified in writing.  
</p>
        </div>
        );
    }
}
export default TOSComponent;